<template>
  <router-link  v-if="$route.name !== 'Contact'" to="/contact" class="fabContact" aria-label="Contactez-nous">
    <span class="fabLabel">{{ $t('contact.fab') }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'ButtonRed',
}
</script>

<style lang="scss" scoped>
.fabContact {
  display: none;

  @media (max-width: 767px) {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 50px;
    right: 18px;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    text-decoration: none;
    z-index: 1000;
    border: 2px solid $accentColor;
    background: white;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: scale(1.08);
    }
  }
}

.fabLabel {
  font-size: 0.48rem;
  font-weight: 700;
  color: $textColor;
  text-align: center;
  letter-spacing: 0px;
  line-height: 1.3;
  white-space: normal;
  width: 48px;
  max-width: 48px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.82);
  border-radius: 4px;
  padding: auto;
  box-sizing: border-box;
}
</style>
